const DayOfWeek = ({type, format}) => {
    let label;

    switch (type) {
        case 1:
        case 'MONDAY':
            label = format === 'short' ? 'Mån' : 'Måndag';
            break;
        case 2:            
        case 'TUESDAY':
            label = format === 'short' ? 'Tis' : 'Tisdag';
            break;
        case 3:
        case 'WEDNESDAY':
            label = format === 'short' ? 'Ons' : 'Onsdag';
            break;
        case 4:          
        case 'THURSDAY':
            label = format === 'short' ? 'Tor' : 'Torsdag';
            break;
        case 5:
        case 'FRIDAY':
            label = format === 'short' ? 'Fre' : 'Fredag';
            break;
        case 6:
        case 'SATURDAY':
            label = format === 'short' ? 'Lör' : 'Lördag';
            break;
        case 0:
        case 'SUNDAY':
            label = format === 'short' ? 'Sön' : 'Söndag';
            break;    
        default:
            label = 'Okänd';
            break;
    }
    return label;
}

const MealType = ({type}) => {
    let label;
    switch (type) {
        case 'BREAKFAST':
            label = 'Frukost';
            break;
        case 'LUNCH':
            label = 'Lunch';
            break;
        case 'DINNER':
            label = 'Middag';
            break;
        default:
            label = 'Okänd';
            break;
    }
    return label;
}

const Diet = ({type}) => {
    let label;
    switch (type) {
        case 'NONE':
            label = 'Ingen';
            break;
        case 'VEGETARIAN':
            label = 'Vegetarisk';
            break;
        case 'VEGAN':
            label = 'Vegansk';
            break;
        case 'GLUTEN_FREE':
            label = 'Glutenfri';
            break;
        default:
            label = 'Ingen';
            break;
    }
    return label;
}

const Unit = ({type, format}) => {
    let label;
    switch (type) {
        case 'PC':
            label = format === 'short' ? 'st' : 'Styck';
            break;
        case 'G':
            label = format === 'short' ?  'g' : 'Gram';
            break;
        case 'KG':
            label = format === 'short' ?  'kg' : 'Kilo';
            break;
        case 'ML':
            label = format === 'short' ?  'ml' : 'Milliliter';
            break;
        case 'KRM':
            label = format === 'short' ?  'krm' : 'Kryddmått';
            break;
        case 'TSP':
            label = format === 'short' ?  'tsk' : 'Tesked';
            break;
        case 'TBSP':
            label = format === 'short' ?  'msk' : 'Matsked';
            break;
        case 'L':
            label = format === 'short' ?  'l' : 'Liter';
            break;
        case 'DL':
            label = format === 'short' ?  'dl' : 'Deciliter';
            break;
        case 'CL':
            label = format === 'short' ?  'cl' : 'Centiliter';
            break;
        default:
            label = 'Ingen';
            break;
    }
    return label;
}

export { DayOfWeek, MealType, Diet, Unit };


// WEBPACK FOOTER //
// ./src/components/Label.js